import firebase from "firebase/compat";
import { getLoginPageUrl } from "./getLoginPageUrl";

export async function logout() {
  await firebase.auth().signOut();
  const url = getLoginPageUrl();
  url.searchParams.set("logout", "true");
  window.location.href = url.toString();
}
